<template>
  <v-field>
    <select-extended v-model="inputValue" :clearable="clearable" :filter="options.length >= 8" autofocus-filter
      :filter-placeholder="$T('type to search')" :float-label="processedLabel" :options="options" :color="color"
      :disable="form.busy || disable" :path="path" :select-all="selectAll" :multiple="multiple" :chips="chips"
      :before="before" :after="after" :autofocus="autofocus" @input="onInput"></select-extended>

    <q-table class="shadow-25 v-list bg-white" style="width:90vw; max-width: 100%;" :pagination.sync="pagination" :data.sync="listLendingKitColors"
      :columns="skuColumns" :title="$T('sku pos stock management')" row-key="id">

      <v-header slot="top" slot-scope="props" :title="$T('sku pos stock management')" icon="list" />

      <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer">
        <q-td v-for="col in props.cols" :key="col.name" :props="props">

          <q-item-main v-if="col.field === 'is_active'">
              <q-icon v-if="col.value" size="1.5em" color="green" name="done"></q-icon>
              <q-icon v-else color="red" size="1.5em" name="close"></q-icon>
          </q-item-main>

          <img height="100px" v-else-if="col.name == 'image' && col.value" :src="`/storage/uploads/${col.value}`" />

          <q-input v-else-if="col.name == 'maximum_stock' || col.name == 'minimum_stock'"
            v-model="listLendingKitColors[props.row.__index][col.name]" @input="onChange" :numeric-keyboard-toggle="true" type="number" />

          <template v-else>{{ col.value }}</template>

        </q-td>
      </q-tr>

    </q-table>

  </v-field>
</template>

<script>
import mixins from './mixins'
import axios from 'axios'

export default {
  name: 'VSelectLendingKitModel',

  mixins,

  props: {
    options: {
      type: Array,
      required: true
    },
    selectAll: Boolean,
    multiple: Boolean,
    chips: Boolean
  },

  mounted() {
    this.getLendingPoints()
  },

  watch: {
    'inputValue': {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler(val) {
        this.getLendingKitColors(val)
      }

    }
  },

  computed: {
    skuColumns() {
      return [
        {
          name: 'lending_kit_model.description',
          label: this.$T('model'),
          field: 'lending_kit_model.description',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'sku',
          label: this.$T('sku code'),
          field: 'sku',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'description',
          label: this.$T('sku description'),
          field: 'description',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'is_active',
          label: this.$T('active / inactive'),
          field: 'is_active',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'image',
          label: this.$T('image'),
          field: 'image',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'minimum_stock',
          label: this.$T('minimum stock'),
          field: 'minimum_stock',
          align: 'left',
          sortable: false,
          required: false
        },
        {
          name: 'maximum_stock',
          label: this.$T('maximum stock'),
          field: 'maximum_stock',
          align: 'left',
          sortable: false,
          required: false
        }
      ]
    }
  },


  data() {
    return {
      number: 5,
      inputValue: [],
      lending_kit_color_id: [],
      listLendingKitColors: [],
      pagination: {
        page: 0,
        rowsPerPage: 0
      }      
    }
  },

  methods: {
    onChange() {

      let total_minimum_stock = 0;
      let total_maximum_stock = 0;

      this.form.lending_kit_color_id = [];

      this.listLendingKitColors.map((el) => {
        total_maximum_stock += el.maximum_stock
        total_minimum_stock += el.minimum_stock

        this.form.lending_kit_color_id.push({
          id: el.id,
          maximum_stock: el.maximum_stock,
          minimum_stock: el.minimum_stock
        })
      })

      this.form.minimum_stock = total_minimum_stock
      this.form.maximum_stock = total_maximum_stock

    },

    getLendingPoints() {
      const { id = null } = this.$route.params
      if (id) {
        axios.get(`/api/v1/lending-point/${id}/lending-kit-models`)
          .then((response) => {
            this.inputValue = response.data
            this.onInput(response.data)
            this.onChange()
          })
      }
    },

    getLendingKitColors(val) {
      const self = this
      if (val.length) {
        return axios.get(`/api/v1/lending-kit-model/colors`, {
          params: {
            'lending_kit_model_id': val,
            'lending_point_id': self.$route.params.id
          }
        })
          .then((response) => {

            response.data.map((el, index) => {
              const elOLD = self.listLendingKitColors.find((e) => e.id === el.id);
              if(elOLD) {
                response.data[index].maximum_stock = elOLD.maximum_stock
                response.data[index].minimum_stock = elOLD.minimum_stock
              }
            })

            self.listLendingKitColors = response.data
            
            self.onChange()
          })
      } else {
        self.listLendingKitColors = [];
        self.onChange()
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VSelectLendingKitModel.vue